import React, { Component } from 'react';
import classnames from 'classnames';
import BodyClassName from 'react-body-classname';

import NavItem from './nav-item';

class Navigation extends Component {
    handleLogout() {
        if (this.props.location.pathname.startsWith('/event/')) {
            let confirmDialog = window.confirm(
                'You have not saved the event. Are you sure you want to leave the page?'
            );
            if (confirmDialog === true) {
                this.props.unAuthUser();
            }
        } else {
            this.props.unAuthUser();
        }
    }
    render() {
        let nav = classnames('nav', { 'is-active': this.props.navActive }),
            expandNav = classnames('nav__expand-btn', {
                'is-active': this.props.expandNav
            }),
            bodyExpandNav = classnames({ 'nav--open': this.props.expandNav }),
            searchBtnClass = classnames('nav__link', 'nav__link--search', {
                'is-active': this.props.searchActive
            });
        return (
            <BodyClassName className={bodyExpandNav}>
                <nav className={nav}>
                    <div className="nav__header">
                        <svg className="icon icon-logo">
                            <use xlinkHref="#icon-logo" />
                        </svg>
                        <button
                            onClick={this.props.toggleMobileNav}
                            className="nav__menu--close"
                        >
                            <svg className="icon icon-close">
                                <use xlinkHref="#icon-close" />
                            </svg>
                        </button>
                    </div>
                    <ul className="nav__list">
                        <li className="nav__list-item">
                            <button
                                onClick={this.props.toggleSearch}
                                className={searchBtnClass}
                            >
                                <svg className="icon icon-search main-icon">
                                    <use xlinkHref="#icon-search" />
                                </svg>
                                <svg className="icon icon-close">
                                    <use xlinkHref="#icon-close" />
                                </svg>
                                <span className="nav__link-title">Search</span>
                            </button>
                        </li>
                        {this.props.items.map((item, index) => (
                            <NavItem
                                key={index}
                                alertsCount={this.props.badgeCount}
                                alertsTouched={false}
                                {...item}
                            />
                        ))}
                        {process.env.NODE_ENV === 'development' ? (
                            <li className="nav__list-item">
                                <span
                                    className="nav__link"
                                    onClick={this.props.unAuthDevUser}
                                >
                                    <svg className="icon icon-logout main-icon">
                                        <use xlinkHref="#icon-logout" />
                                    </svg>
                                    <span className="nav__link-title">
                                        Sign Out
                                    </span>
                                </span>
                            </li>
                        ) : (
                            <li className="nav__list-item">
                                <span
                                    className="nav__link"
                                    onClick={this.handleLogout.bind(this)}
                                >
                                    <svg className="icon icon-logout main-icon">
                                        <use xlinkHref="#icon-logout" />
                                    </svg>
                                    <span className="nav__link-title">
                                        Sign Out
                                    </span>
                                </span>
                            </li>
                        )}
                    </ul>
                    <div
                        onClick={this.props.toggleExpandNav}
                        className="nav__expand"
                    >
                        <button
                            className={expandNav}
                            title="Expand/Collapse Nav"
                        >
                            <svg className="icon icon-expand">
                                <use xlinkHref="#icon-expand" />
                            </svg>
                        </button>
                    </div>
                </nav>
            </BodyClassName>
        );
    }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/navigation/index.js